import React, { useState, useRef } from "react";

import CreateCoupon from "./CreateCoupon";
import CouponTable from "./CouponTable";

const ManageUnlimitedAmountCoupons = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [highlightedRowId, setHighlightedRowId] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const pageSetterRef = useRef(null);

  return (
    <div className="px-6 py-10 text-white">
      <CreateCoupon
        couponType="unlimited"
        isFixedAmount={true}
        setHighlightedRowId={setHighlightedRowId}
        setRefreshTrigger={setRefreshTrigger}
        pageSetterRef={pageSetterRef}
      />
      <CouponTable
        refreshTrigger={refreshTrigger}
        highlightedRowId={highlightedRowId}
        setShowConfirm={setShowConfirm}
        setSelectedCoupon={setSelectedCoupon}
        showConfirm={showConfirm}
        selectedCoupon={selectedCoupon}
        setRefreshTrigger={setRefreshTrigger}
        statusFilter="Unlimited"
        isFixedAmount={true}
      />
    </div>
  );
};

export default ManageUnlimitedAmountCoupons;
